import React from 'react';
import { motion } from 'framer-motion';
import { fadeIn } from '../../utils/animations';
import { ExternalLink } from 'lucide-react';

const Events = () => {
  return (
    <div className="flex flex-col items-center w-full max-w-4xl mx-auto px-4">
      <motion.h1
        variants={fadeIn}
        className="font-['Orbitron'] text-3xl text-white mb-12 text-center"
      >
        Upcoming Events
      </motion.h1>

      <motion.div
        variants={fadeIn}
        className="w-full max-w-2xl mx-auto"
      >
        <a
          href="https://partiful.com/e/2OQP5YfBJlF0OvkWPZzP" // Replace with actual Eventbrite link
          target="_blank"
          rel="noopener noreferrer"
          className="group block relative rounded-lg overflow-hidden transition-transform hover:-translate-y-2"
        >
          {/* Event Image */}
          <img
            src="/return-of-emcee.png"
            alt="Return of the Emcee IX Event"
            className="w-full h-auto rounded-lg"
          />
          
          {/* Overlay with ticket info */}
          <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
            <div className="text-white text-center p-4">
              <p className="font-['Orbitron'] text-xl mb-2">Get Tickets</p>
              <div className="flex items-center gap-2">
                <ExternalLink size={20} />
                <span>Click to purchase on Eventbrite</span>
              </div>
            </div>
          </div>
          
          {/* Event Details */}
          <div className="bg-[#1A1A1A] p-4 mt-4 rounded-lg">
            <h2 className="font-['Orbitron'] text-xl text-white mb-2">Return of the Emcee IX</h2>
            <div className="text-gray-300">
              <p>January 18th, Saturday @ 8PM</p>
              <p>Elbo Room - 311 Broadway, Oakland</p>
              <p>$5 Cover | 21+ | January Birthdays Free</p>
            </div>
          </div>
        </a>
      </motion.div>
    </div>
  );
};

export default Events;